export default {"src":"/_next/static/media/step1b.e1867298.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};